import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';

import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm$supplierPrice;
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    attrs: {
      persistent: ""
    },
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  })], 1), _c(VCardTitle, [_c("div", {
    staticClass: "text-h5"
  }, [_vm._v(" New Wine "), (_vm$supplierPrice = _vm.supplierPrice) !== null && _vm$supplierPrice !== void 0 && _vm$supplierPrice.description ? _c("span", {
    staticClass: "text-smaller"
  }, [_vm._v(" - " + _vm._s(_vm.supplierPrice.description) + " - " + _vm._s(_vm.supplierPrice.price) + "€ ")]) : _vm._e()])]), _vm.isWineComponentVisible ? _c("wine", {
    attrs: {
      idWine: _vm.id_wine,
      loggedUserData: _vm.loggedUserData,
      searchCriterias: _vm.searchCriterias,
      returnRoute: _vm.returnRoute,
      paramRoute: _vm.routeParam,
      producerIdInPO: _vm.producerId,
      supplierPrice: _vm.supplierPrice,
      wineForCloning: _vm.wineForCloning
    },
    on: {
      closeNewWineDialog: _vm.close,
      newWineSaved: _vm.saved
    }
  }) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };